import { createContext, useContext } from "react";

export interface LivePlayerContextValue {
    isOpen: boolean;
    url: string;
}

const defaultValue: LivePlayerContextValue = {
    isOpen: false,
    url: "",
};

export const LivePlayerContext = createContext<LivePlayerContextValue>(defaultValue);

export function useLivePlayer() {
    return useContext(LivePlayerContext);
}
